export interface MatchStats {
  Id: string;
  TsExternalId: string;
  Stats: MatchStat[];
}

export interface MatchStat {
  AwayValue: number;
  HomeValue: number;
  Kind: EStatKind;
  Measure: EStatMeasure;
}

export enum EStatKind {
  POSSESSION = 'POSSESSION',
  ON_TARGET = 'ON_TARGET',
  OFF_TARGET = 'OFF_TARGET',
  CORNER = 'CORNER',
  PENALTY = 'PENALTY',
  YELLOW_CARD = 'YELLOW_CARD',
  RED_CARD = 'RED_CARD',
  ATTACK = 'ATTACK',
  DANGEROUS_ATTACK = 'DANGEROUS_ATTACK',
}

export enum EStatMeasure {
  PERCENTAGE = 'PERCENTAGE',
  QUANTITY = 'QUANTITY',
}

export const emptyMatchStats: MatchStats = {
  Id: '',
  TsExternalId: '',
  Stats: [],
};
